<template>
  <div class="survey-detail-container">
    <div class="survey-detail-header">
      <div class="header-left">
        <div class="survey-detail-title">
          <div class="survey-detail-title-text">Survey Results</div>
        </div>
        <div class="survey-detail-name">
          <div class="survey-detail-name-text" v-if="survey.name">
            {{ survey.name }}
          </div>
          <div class="survey-detail-name-text" v-else>No Name</div>
        </div>
      </div>

      <div class="header-right">
        <div class="survey-detail-buttons">
          <b-button
            class="survey-detail-button"
            v-if="individual == true"
            v-on:click="switchViews"
          >
            View Aggregate
          </b-button>
          <b-button
            class="survey-detail-button"
            v-on:click="switchViews"
            v-if="individual == false"
          >
            View Individual
          </b-button>
          <b-button class="survey-detail-button" v-on:click="downloadCSV">
            Download CSV
          </b-button>
        </div>
      </div>
    </div>

    <hr class="divider" />
    <div class="survey-detail-body">
      <div class="survey-detail-description">
        <div class="survey-detail-subtitle category">
          Description
        </div>
        <div class="survey-detail-description-text" v-if="survey.description">
          {{ survey.description }}
        </div>
        <div class="survey-detail-description-text" v-else>
          This survey has no description.
        </div>
      </div>

      <div class="survey-detail-questions" v-if="this.individual == true">
        <div class="survey-detail-subtitle">
          <div v-if="this.testerList.length != 0">
            <div class="category">
              Tester:
            </div>
            {{ this.currTester }}
          </div>
          <div v-else>
            No testers assigned to survey.
          </div>
          <button
            class="survey-btn"
            v-if="this.testerList.length != 0"
            v-on:click="getCurrTester(currTesterID - 1)"
          >
            Prev
          </button>
          <button
            class="survey-btn"
            v-if="this.testerList.length != 0"
            v-on:click="getCurrTester(currTesterID + 1)"
          >
            Next
          </button>
        </div>
        
        <div v-if="testerResponse.responses != null">
          <div class="survey-detail-subtitle category">
          Questions
          </div>
          <div v-if="survey.questions.length === 0 || this.testerList.length === 0" class="no-questions-message">
          No questions available.
          </div>
          <div v-else class="questions-container">
          <div
            v-for="(question, qIndex) in survey.questions"
            class="question-container"
          >
            <div class="question-header">
              <div class="qheader-left">
                <div class="question-title">Q{{ qIndex + 1 }}.</div>
                <div class="question-title">{{ question.content.title }}</div>
              </div>
              <div class="qheader-right">
                <div class="question-type">
                  {{ formatQType(question.qType) }}
                </div>
              </div>
            </div>

            <hr class="divider" />
            <div class="question-body">
              <div
                v-if="processQuestionContent(question).length === 0"
                class="no-options-message"
              >
                No options available.
              </div>

              <div v-else class="question-content-container">
                <ResultsQuestion v-if="testerResponse.responses && processQuestionContent(question)" :questionContent="processQuestionContent(question)" :qType="question.qType" :resp="testerResponse.responses[qIndex]" />
              </div>
            </div>
          </div>
          </div>
        </div>

        <div v-else class="no-response-text">
        This tester has not filled out a response.
        </div>
      </div>

      <div class="game-detail-description" v-if="this.individual == false">
        <div class="survey-detail-questions">
          <div class="survey-detail-subtitle category">
            Questions
          </div>

          <div class="questions-container">
            <div
              v-for="(question, qIndex) in survey.questions"
              class="question-container"
            >
              <div class="question-header">
                <div class="qheader-left">
                  <div class="question-title">Q{{ qIndex + 1 }}.</div>
                  <div class="question-title">{{ question.content.title }}</div>
                </div>
                <div class="qheader-right">
                  <div class="question-type">
                    {{ formatQType(question.qType) }}
                  </div>
                </div>
              </div>

              <hr class="divider" />

              <div class="question-body">
                <div
                  v-if="processQuestionContent(question).length === 0"
                  class="no-options-message"
                >
                  No options available.
                </div>

                <div v-else class="question-content-container">
                  <component
                    :is="getComponent(question.qType)"
                    :qIndex="qIndex"
                    :qType="question.qType"
                    :allResponses="allResponses"
                    :options="processQuestionContent(question)"
                  >
                    {{ computeAvg(question.qType, qIndex) }}
                  </component>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Accordion from "../../survey-reporting/TextAccordion.vue";
import BarChart from "../../survey-reporting/BarChart.vue";
import ResultsQuestion from "./ResultsQuestion.vue";
import UserObject from "../../../Firestore/UserObject.js";
import Response from "../../../Firestore/Response.js";
import ExportSurveyAnalytics from "../../../Firestore/ExportSurveyAnalytics.js";
import Events from "../../../Firestore/Events.js";

export default {
  name: "results",
  components: {
    Accordion,
    BarChart,
    ResultsQuestion
  },
  props: {
    detail: {
      type: Object
    },
    survey: {
      type: Object
    },

    weightedAvg: {
      type: Object
    }
  },
  data() {
    return {
      surveyObj: [],
      barChartData: [12, 19, 3, 5, 2, 3],
      testerList: [],
      currTester: null,
      currTesterID: 0,
      openQuestions: [],
      testerResponse: {},
      individual: true,
      displayedAggregate: "No aggregate",
      allResponses: [],
      accordionList: []
    };
  },

  mounted() {
    Response.getResponsesBySurvey(this.survey.sID)
      .then(res => {
          let res_data = res.data;
          this.allResponses = res_data;
          this.testerList = this.allResponses.map(t => t.testerID)
          this.getCurrTester(0);
          Events.logEvent("results.viewed", {
            surveyId: this.survey.sID,
            responses: res_data ? res_data.length : 0,
          });
      })
      .catch(function (error) { // request failure handler
          that.$data.isLoading = false;
      });
  },

  methods: {
    // Go back to main Analysis menu
    toDetailAnalysis() {
      this.$emit("toDetailAnalysisChild");
    },
    async downloadCSV() {
      console.log(this.survey.sID);
      try {
        const response = await ExportSurveyAnalytics.exportCSVBySurvey(
          this.survey.sID, this.survey.questions
        );
        

        if (response.success === true) {
          const blob = new Blob([response.data], {
            type: "text/csv;charset=utf-8"
          });
          const link = document.createElement("a");

          link.href = URL.createObjectURL(blob);
          link.download = this.survey.name + " responses.csv";

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.error("Failed to export CSV: ", response.error);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    getComponent(qType) {
      switch (qType) {
        case "multi-choice":
          //Return an array containing each text within question.content.options
          return "bar-chart";
        case "multi-select":
          return "bar-chart";
        case "dropdown":
          return "bar-chart";
        case "text-answer":
          return "Accordion";
        case "linear-scale":
          return "div";
        default:
          return "div";
      }
    },

    computeAvg(qType, qI) {
      //Gets a question and its type, calculates aggregate
      if (this.allResponses.length == 0 || qType != "linear-scale") {
        return "No aggregate";
      }
      var sum = 0; //Variable for sum of linear scale answers
      var responders = 0;

      for (let i = 0; i < this.allResponses.length; i++) {
        if (
          this.allResponses == null ||
          this.allResponses[i] == null ||
          this.allResponses[i].responses == null
        ) {
          continue;
        }
        var currResponse = this.allResponses[i].responses[qI]; //Now we have a user's response object to the given question

        sum += currResponse.value;
        responders += 1;
      }

      if (responders == 0) {
        responders = 1;
      }
      var avg = `Weighted Average: ${(sum / responders).toFixed(
        4
      )} calculated from ${responders} responder(s)`;
      return avg;
    },

    async getTesterName(id) {
      return new Promise(async (resolve, reject) => {
        await UserObject.getProfile(id)
          .then(res => {
            let res_data = res.data;
            this.currTester = res_data.userName;
          })
          .catch(function(error) {
            // request failure handler
            that.$data.isLoading = false;
          });
      });
    },

    async getCurrTester(testerIndex) {
      if (testerIndex >= this.testerList.length) {
        testerIndex = 0;
      } else if (testerIndex < 0) {
        testerIndex = this.testerList.length - 1;
      }
      this.currTesterID = testerIndex;
      this.testerResponse = this.allResponses[this.currTesterID]
      await this.getTesterName(this.testerResponse.testerID);
    },

    toggleQuestion(index) {
      if (this.openQuestions.includes(index)) {
        this.openQuestions = this.openQuestions.filter(i => i !== index);
      } else {
        this.openQuestions.push(index);
      }
    },
    formatQType(qtype) {
      const formattedQType = qtype
        .split("-")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

      return formattedQType;
    },
    processQuestionContent(question) {
      switch (question.qType) {
        case "multi-choice":
          //Return an array containing each text within question.content.options
          //console.log(question.content.options.map(option => option.text));
          return question.content.options.map(option => option.text);
        case "multi-select":
          //console.log(question.content.options);
          return question.content.options;
        case "dropdown":
          //console.log(question.content.options);
          return question.content.options;
        case "text-answer":
          return ["Text Answer"];
        case "linear-scale":
          return [question.content.startLabel, question.content.endLabel];
        default:
          return [];
      }
    },

    switchViews() {
      this.individual = !this.individual;
    }
  }
};
</script>

<style scoped>



.survey-btn,
.survey-btn-add {
  background-color: #fc7727 !important;
  color: #fff;
  border: none;
  border-radius: 10px !important;
}

.survey-btn-add {
  width: 75%;
  margin-bottom: 3%;
  padding: 1%;
}

.survey-btn {
  height: fit-content;
}

.survey-btn:hover,
.survey-btn-add:hover {
  background-color: #ff8e4d !important;
}
.survey-title {
  color: #000 !important;
  font-size: large;
}

.new-text {
  font-style: italic;
  color: #bebebe;
}

.viewresults-back {
  height: 21px;
  font-size: 16px;
  line-height: 21px;
  text-decoration-line: underline;
  color: #000000;
  margin-bottom: 34px;
  cursor: pointer;
}

.white-text {
  color: #000000;
}

.game-detail-description {
  /* position: relative; */
  font-weight: bold;
  /* margin-right: 5%; */
  margin: 2%;
}
.survey-detail-container {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  width: 100%;
}

.survey-detail-header {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 10%;
  min-height: 10%;
  width: 100%;
  background-color: #fff;
  border-radius: 10px;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
}

.header-left {
  margin-left: 5%;
  display: flex;
  flex-direction: row;
}
.header-right {
  margin-right: 2.5%;
  display: flex;
  flex-direction: row;
}
.survey-detail-title {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 100%;
  /* width: 50%; */
  align-items: center;
  justify-content: center;
}
.survey-detail-title-text {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 46px;
  color: #fc7727;
  vertical-align: bottom;
}
.survey-detail-name {
  font-family: Lato;
  font-style: italic;
  font-weight: bold;
  margin-left: 10px;
  margin-top: 15px;
  color: #909090;
  vertical-align: bottom;
}
.survey-detail-buttons {
  float: right;
}
.survey-detail-button {
  background-color: #fc7727 !important;
  color: #fff;
  border: none;
  border-radius: 10px !important;
  padding: 0.25rem 0.5rem;
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.2);
}
.survey-detail-button:hover {
  background-color: #ff8e4d !important;
}
.divider {
  border: 1px solid #c2c2c2;
  width: 95%;
  margin: 0 auto;
}
.survey-detail-subtitle {
  font-family: Lato;
  font-style: normal;
  font-size: 20px;
  color: #fc7727;
  line-height: 46px;
  margin-top: 5px;
}
.category {
  font-weight: bold;
}

.survey-detail-body {
  margin-left: 5%;
  margin-right: 5%;
  overflow-y: auto;
}
.survey-detail-body::-webkit-scrollbar {
  display: none;
}

.survey-detail-description-text {
  font-family: Lato;
  color: #bebebe;
}
.tag-container {
  display: flex;
  flex-wrap: wrap;
}

.tag-capsule {
  background-color: #db3360;
  color: white;
  border-radius: 10px;
  padding: 5px 10px;
  margin-right: 8px;
  margin-bottom: 5px;
  box-shadow: 0px 4px 10px rgba(219, 51, 96, 0.3);
}
.question-header {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 100%;
  width: 100%;
  margin-bottom: 10px;
  margin-top: 10px;
  cursor: pointer;
}
.qheader-left {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 100%;
  width: 70%;
  align-items: center;
  justify-content: flex-start;
}
.qheader-right {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 100%;
  width: 30%;
  align-items: center;
  justify-content: flex-end;
}
.question-title {
  font-weight: bold;
  margin-left: 5px;
  font-family: Lato;
  font-style: normal;
  font-size: 20px;
}
.question-type {
  font-family: Lato;
  font-style: italic;
  margin-right: 10px;
  color: #bebebe;
  vertical-align: bottom;
}

.question-body {
  margin-left: 20px;
  margin-bottom: 5px;
}

.question-content-container {
  display: flex;
  flex-direction: column;
}

.question-content {
  display: flex;
  align-items: flex-start;
  margin-left: 20px; /* Adjust the margin as needed */
}

.question-content::before {
  /* content: '•'; */
  margin-right: 5px; /* Adjust the margin as needed */
}
.no-response-text {
  font-size: 0.95rem;
  color: #6c757d;
  font-style: italic;
  margin-top: 0.5rem;
  margin-left: 20px; 
}

</style>



// WEBPACK FOOTER //
// src/components/game-detail/Surveys/Results.vue